// Captions are always shown while editing and an empty one is not saved:
// media (pictures, videos, embeds, tables) sit in a captioned figure in the
// editor, and a figure with an empty caption is saved as the bare media.
// Galleries likewise always show their caption line.
const MEDIA = ['image', 'video', 'embed', 'table'];
const emptyCaption = (n) => n?.type === 'caption' && !n.content?.length;

export function captionsForEditing(node) {
  if (!node.content) return node;
  let content = node.content.map((c) =>
    MEDIA.includes(c.type) && node.type !== 'figure'
      ? { type: 'figure', content: [captionsForEditing(c), { type: 'caption' }] }
      : captionsForEditing(c)
  );
  if (node.type === 'gallery' && content[content.length - 1].type !== 'caption')
    content = [...content, { type: 'caption' }];
  return { ...node, content };
}

export function captionsForSaving(node) {
  if (!node.content) return node;
  let content = node.content.map((c) =>
    c.type === 'figure' && emptyCaption(c.content[c.content.length - 1])
      ? captionsForSaving(c.content[0])
      : captionsForSaving(c)
  );
  if (node.type === 'gallery' && emptyCaption(content[content.length - 1])) content = content.slice(0, -1);
  return { ...node, content };
}
